import { needsHTMLRendering } from '@audacy-clients/core/utils/strings';
import isEmpty from 'lodash/isEmpty';
import type { FC, ReactNode } from 'react';
import HTML from '~/components/HTML';
import type { TStyles } from '~/types/emotion-styles';
import styles from './styles';

type IProps = {
  description: string;
  render?: (children: ReactNode) => JSX.Element;
  shouldStripTags?: boolean;
  shouldStripInteractiveTags?: boolean;
  shouldDecodeHtml?: boolean;
  textCss?: TStyles;
};

const DescriptionWrapper: FC<IProps> = ({
  description,
  render,
  shouldStripTags = false,
  shouldStripInteractiveTags = false,
  shouldDecodeHtml = false,
  textCss,
}) => {
  if (!isEmpty(description)) {
    const element =
      needsHTMLRendering(description) || shouldDecodeHtml ? (
        <HTML
          shouldStripTags={shouldStripTags}
          shouldStripInteractiveTags={shouldStripInteractiveTags}
          text={description}
          textCss={textCss}
        />
      ) : (
        <p css={[styles.text, textCss]}>{description}</p>
      );
    return render ? render(element) : element;
  }

  return <></>;
};

export default DescriptionWrapper;
